(() => {
  class PetomgDimensions extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-unit]')];
      this.values = [...this.querySelectorAll('[data-mm]')];
      this.buttons.forEach((button) => button.addEventListener('click', () => this.setUnit(button.dataset.unit)));
      this.setUnit(this.dataset.unit || 'in');
    }

    setUnit(unit) {
      this.dataset.unit = unit;
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
      this.values.forEach((node) => {
        const values = node.dataset.mm.split(',').map(Number);
        node.textContent = `${values.map((value) => (unit === 'cm' ? value / 10 : value / 25.4).toFixed(1)).join(' × ')} ${unit === 'cm' ? 'cm' : 'in'}`;
      });
    }
  }

  if (!customElements.get('petomg-dimensions')) customElements.define('petomg-dimensions', PetomgDimensions);
})();
